export const LICENSE_CHANGE_VIEWS = {
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
  MOVE_TO_ISACA: 'move-to-isaca',
  FREE: 'free',
  PAID: 'paid',
  MOVE_TO_ORG: 'move-to-org',
  CHANGE_SPONSORING_PARTNER: 'change-sponsoring-partner'
};
